import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { profileIcon, settingsIcon, logOutIcon, verifiedPic, graduationCap, teacherVerifiedIcon } from './Icons';
import CachedImage from './Modules/CachedImage';
import { version } from './Modules/Exports';
import ResponsiveUsername from './Modules/ClipName';

const Dropdown = ({ loggedIn, akrAuth = {}, onLogout }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const {
    profilePicture = "",
    fullName = "",
    schoolVerified = false,
    verified = false,
    teacherVerified = false,
    userId = 0
  } = akrAuth;

  const handleDropdownItemClick = (route) => {
    setIsOpen(false);
    navigate(`/${route.toLowerCase()}`);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="dropdown" onClick={toggleDropdown}>
      {loggedIn ? (
        <>
          <ResponsiveUsername fullName={fullName} className="navbar-username" />
          {verified && <CachedImage className="navbar-verified-pic" src={verifiedPic} userId="verifiedPic" alt="Verified" />}
          {schoolVerified && !verified && <CachedImage className="navbar-verified-pic" src={graduationCap} userId="graduationCap" alt="School Verified" />}
          {teacherVerified && !schoolVerified && !verified && <CachedImage className="navbar-verified-pic" src={teacherVerifiedIcon} userId="teacherVerifiedIcon" alt="Teacher Verified" />}
          <CachedImage userId={Number(userId)} src={profilePicture} className="navbar-profile-pic" alt="Profile" />
        </>
      ) : (
        <button className="dropdown-button" onClick={() => navigate('/login')}>
          Log in
        </button>
      )}
      {isOpen && loggedIn && (
        <div className="dropdown-content">
          <button onClick={() => handleDropdownItemClick('Profile')}>
            <img src={profileIcon} userId="profileIcon" alt="Profile" />
            <span>Profile</span>
          </button>
          <button onClick={() => handleDropdownItemClick('Settings')}>
            <img src={settingsIcon} userId="settingsIcon" alt="Settings" />
            <span>Options</span>
          </button>
          <button onClick={onLogout}>
            <img src={logOutIcon} userId="logOutIcon" alt="Log Out" />
            <span>Sign Out</span>
          </button>
          <div className="build-number">{version}</div>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
